import { InputRule } from '@tiptap/core';

import { Link } from './Link';
import { isValidUrl } from './isValidUrl';

const markdownLinkInputRegex = /(?:^|\s)\[([^\]\n]+)\]\(([^\s)]+)\)$/;

export const MarkdownLink = Link.extend({
  addInputRules() {
    return [
      new InputRule({
        find: markdownLinkInputRegex,
        handler: ({ state, range, match }) => {
          const [markdownLink, label, href] = match;
          if (!label || !href || !isValidUrl(href)) return;

          const leadingWhitespaceLength =
            markdownLink.length - markdownLink.trimStart().length;
          const linkStart = range.from + leadingWhitespaceLength;
          const linkMark = this.type.create({ href });

          state.tr
            .replaceWith(
              linkStart,
              range.to,
              state.schema.text(label, [linkMark]),
            )
            .removeStoredMark(this.type);
        },
      }),
    ];
  },
});
